import Service 			from "./../../Libs/Service";

let ScreenService = new Service({

	Name: "Screen",

	Libraries: [],

	Events: {

		//Переключение рабочей ноды: активные карты данных подменяются картами этой ноды
		"Cluster Working Node Changed": function(previousServerId, serverId) {

			this.useServer(serverId);

		},

		"Settings Tab Changed:elements": function() {

			if (!this.SelectedScreen || this.SelectedScreen['version_id'] !== Version.SelectedVersion?.id) this.autoSelectScreen();

		}

	},

	Actions: {

		//Получение всех экранов креатива или версии (serverId - нода, с которой пришли данные)
		"Screens": function(screens, data, size, serverId) {

			if (data.ScreensCreativeId) {

				this.setScreens(screens, serverId);

				//Первоначальная загрузка экранов всех версий креатива
				Broadcast.call("Creative Screens Loaded", [data.ScreensCreativeId]);

			} else if (data.ScreensVersionId) {

				this.setScreens(screens, serverId);

				//Первоначальная загрузка экранов одной версии (дублирование версии или создание из шаблона)
				Broadcast.call("Version Screens Loaded", [data.ScreensVersionId]);

			}

		},

		"Screen": function(screen, data, size, serverId) {

			let oldScreen = this.getServerMap(this.ScreensByVersionByCodenameByServer, serverId || this.NodeServerId)[data.ScreenVersionId]?.[data.ScreenCodename];

			this.setScreen(data.ScreenVersionId, data.ScreenCodename, screen, serverId);

			this.detectScreenChanges(oldScreen, screen);

		}

	},

	init() {

		//Карты данных по нодам кластера: у каждой ноды своя БД, и id версий и экранов
		//на разных нодах совпадают, поэтому карты разделены по нодам (Client/Libs/Service.js, getServerMap)
		this.ScreensByVersionByCodenameByServer = {};

		// Активные карты - карты рабочей ноды
		this.useServer(0);

	},

	// Активные карты данных рабочей ноды: при переключении ноды они подменяются ссылками на карты
	// этой ноды, поэтому код обращения к ним (ScreensByVersionByCodename[versionId]) не меняется
	useServer(serverId) {

		serverId = serverId || 0;

		if (this.NodeServerId === serverId) return;

		this.NodeServerId = serverId;

		this.ScreensByVersionByCodename = this.getServerMap(this.ScreensByVersionByCodenameByServer, serverId);

	},

	// serverId - нода, с которой пришли данные: пишем в карты этой ноды
	setScreens(versionsScreens, serverId) {

		let screensByVersion = this.getServerMap(this.ScreensByVersionByCodenameByServer, serverId || this.NodeServerId);

		_.each(versionsScreens, (versionScreens, versionId) => {

			screensByVersion[versionId] = versionScreens;

		});

	},

	setScreen(versionId, screenCodename, screen, serverId) {

		let screensByVersion = this.getServerMap(this.ScreensByVersionByCodenameByServer, serverId || this.NodeServerId);

		screensByVersion[versionId][screenCodename] = screen;

	},

	detectScreenChanges(oldScreen, newScreen) {

		//TODO:

	},

	autoSelectScreen() {

		let versionScreens = ScreenService.getVersionScreens(Version.SelectedVersion);

		let screens = _.sortBy(_.values(versionScreens), 'priority');

		if (this.SelectedScreen !== screens[0]) this.selectScreen(screens[0]);

	},

	selectScreen(screen) {

		this.SelectedScreen = screen;

		Broadcast.call("Selected Screen Switched", [this.SelectedScreen]);

	},

	// Экран, с которым сейчас работает дашборд: экран, выбранный в дашборде, а если он ещё не выбран
	// (например, сразу после загрузки дашборда) - первый экран версии (как в autoSelectScreen)
	getCurrentScreen() {

		let selectedScreen = this.SelectedScreen;

		// Выбранный экран подходит, если он принадлежит открытой версии (при смене версии экран выбирается заново)
		if (selectedScreen && selectedScreen['version_id'] === Version.SelectedVersion?.id) return selectedScreen;

		let versionScreens = Version.SelectedVersion ? this.getVersionScreens(Version.SelectedVersion) : {};

		return _.sortBy(_.values(versionScreens), 'priority')[0] || null;

	},

	getVersionScreens(version) {

		return this.ScreensByVersionByCodename[version.id] || {};

	}

});

window.ScreenService = ScreenService;

export { ScreenService }

